export const appConfig = {
  api: {
    // url: 'https://api.fartoy.havbruksloggen.no',
    url: process.env.REACT_APP_API_URL,
    // url: 'https://api.crud.no',
  },
  applicationInsight: {
    key: process.env.REACT_APP_INSIGHTS,
  },
  identityServer: {
    authority: process.env.REACT_APP_IDENTITY_SERVER_AUTHORITY,
    client_id: process.env.REACT_APP_IDENTITY_SERVER_CLIENT_ID,
    clientSecret: 'd7174bb7-49e0-4d6a-85fe-f8ef0a531764',
    scope: process.env.REACT_APP_IDENTITY_SERVER_SCOPE,
  },
}

export default appConfig
